import { babyStationSlice } from "./reducer";

export const {
  changeMotionSensitivity,
  setMicSensitivity,
  setMicSensitivityCorrection
} = babyStationSlice.actions;
